// extracted by mini-css-extract-plugin
export var component = "ReadTime-module--component--9ead9";
export var fadePop = "ReadTime-module--fade-pop--9caf2";
export var growHeightIn = "ReadTime-module--grow-height-in--7ecba";